<div class="rubros">
  <ng-container *ngFor="let r of tipos">
  <button *ngIf="tiposEnable.indexOf(r.id) !== -1"
          mat-stroked-button
          (click)="tipoChange(r.id)"
          [class]="r.id === tipo ? 'btn-rubro-sel' : ''">

<!--    <fa-icon icon="check" *ngIf="r.key === rubro"></fa-icon>-->
    <span>{{ rubroName(r) }}</span>
  </button>
  </ng-container>
</div>
